const resource = {
    resource_identifier_in_use: 'API tanımlayıcısı {{indicator}} zaten kullanımda',
    cannot_delete_management_api: "Logto yönetim API'sini silemezsiniz.",
    cannot_modify_management_api: "Logto yönetim API'sini değiştiremezsiniz.",
};
export default Object.freeze(resource);
